const renumeracao_automatica_diario_de_classe = {
  path: "/renumeracao-automatica-diario-de-classe",
  redirect: "/renumeracao-automatica-diario-de-classe",
  meta: {
    breadCrumb: "Processo de Matrículas - Diário Classe da Turma",
  },
  children: [
    {
      path: "/renumeracao-automatica-diario-de-classe",
      name: "renumeracao-automatica-diario-de-classe",
      component: () =>
        import(
          "@/views/RenumeracaoAutomaticaDiarioClasse/RenumeracaoAutomaticaDiarioClasse.vue"
        ),
    },
  ],
};

export { renumeracao_automatica_diario_de_classe };
